import { Component, OnInit, HostListener, OnDestroy } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { StoreHelper } from "../shared/helpers/store.helper";
import { Observable, Subscription, timer } from "rxjs";

declare var $: any;

import { User } from "../shared/models";
import { routerTransition } from "../shared/animations";
import { ControllerService } from "../shared/services/controller.service";
import { ToggleService } from "../shared/services/toggle.service";

@Component({
    selector: "app-rating",
    templateUrl: "./rating.component.html",
    styleUrls: ["./rating.component.scss"],
    host: { "[@routerTransition]": "" },
    animations: [routerTransition],
    standalone: false
})
export class RatingComponent implements OnInit, OnDestroy {
  user: User;
  mediaFinished: boolean = false;
  progressValue: any = 0;
  currentMedia: number = 0;
  ratingList: any = [];
  audioRatingList: any[];

  startAt: number = 0;

  ratings: any = [];

  lastMouseMove: number = 0;
  ticks = 0;
  mouseInScreen: boolean = true;
  secondsDisplay: number = 0;
  timerSubscription: Subscription;

  playingVideo: boolean = false;
  playingAudio: boolean = true;
  completedSection: boolean = false;


  previewing: boolean = false

  skipToEnd: boolean = false;

  isBunny: boolean = false;

  example: boolean = false;

  question: string = "";

  qpListener: Subscription | null = null
  paramListener: Subscription | null = null

  constructor(
    private route: ActivatedRoute,
    public controller: ControllerService,
    toggleService: ToggleService,
  ) {
    this.isBunny = toggleService.isEnabled('bunny');
  }

  async ngOnInit() {
    $("body").removeClass();

    this.previewing = this.controller.getPreviewing()

    let ratings = await this.controller.getTempData("ratings")

    this.ratings = ratings && ratings.length ? ratings : [];

    this.skipToEnd = StoreHelper.getObject("fastForward") ? true : false;

    // The same RatingComponent instance is reused when navigating between
    // /rating/audio and /rating/video (both match rating/:section), so ngOnInit
    // does not run again. Re-load the section-specific state on every :section
    // change, otherwise the audio view stays shown and the clip index resets.
    this.paramListener = this.route.params.subscribe(() => {
      this.loadSection();
    });

    this.qpListener = this.route.queryParams.subscribe((queryParams: Params) => {
      this.startAt = this.controller.getPage();
    });
  }

  // Loads the state that depends on the current rating section (audio vs video).
  private loadSection() {
    this.question = this.controller
      .getSectionComponents()
      .find(({ type }) => type == "page").elements[0].value;

    this.playingAudio = this.controller.getSectionProperties().type == "audio";
    this.playingVideo = this.controller.getSectionProperties().type == "video";

    this.ratingList = this.controller
      .getSectionComponents()[0]
      .subComponents.filter(({ type }) => type == "rating-component")
      .map(({ properties }) => {
        return {
          ...properties,
        };
      });

    this.startAt = this.controller.getPage();
  }

  ngOnDestroy() {
    if (this.timerSubscription) this.timerSubscription.unsubscribe();

    if (this.qpListener) this.qpListener.unsubscribe()
    if (this.paramListener) this.paramListener.unsubscribe()
  }

  @HostListener("mousemove", ["$event"])
  onMousemove(event: MouseEvent) {
    this.lastMouseMove = new Date().getTime();
    this.ticks = 0;
  }

  onMouseleave($event) {
    this.mouseInScreen = false;
    if (!this.mediaFinished) {
      this.fadeOutControls();
    }
  }

  onMouseenter($event) {
    this.mouseInScreen = true;
    if (!this.mediaFinished) {
      this.fadeInControls();
    }
  }

  //after media started (called by audio/video component)
  onStartedMedia() {
    this.mediaFinished = false;
    this.startTimer();
  }

  //after media finished (called by audio/video component)
  onFinishedMedia() {
    if (this.timerSubscription) this.timerSubscription.unsubscribe();
    setTimeout(this.fadeInControls, 1000);
    this.mediaFinished = true;
  }

  // Happens after you have DONE A RATING (called by audio/video component)
  async onPlayedMedia(playedMedia: {
    currentPlayGame: number;
    votedValue: number;
    gameElem: any;
  }) {
    await this.controller.next();

    console.log("played media");
  }

  // after all items played & rated
  async onEndSection() {
    console.log("on end section!");
    // await this.controller.next()
  }

  onEmitRating(event) {

    if (event.example == 'true') {
      this.controller.next();
      return;
    }

    // if we already have a rating for this id, ignore.

    const existing = this.ratings.find( ({id, isAudio}) => id == event.id && isAudio == event.isAudio)
    if( existing ){
      console.log('have existing %o, ignoring. %o', existing, event)
      this.controller.next();
      return
    }

    this.ratings.push({
      ...event,
    });

    this.controller.next();
    this.controller.storeTempData("ratings", this.ratings);
  }

  fadeOutControls() {
    if (parseInt($(".controls-container").css("opacity")) !== 0) {
      $(".title-container").css("opacity", 0);
      $(".controls-container").css("opacity", 0);
      $(".voting-container").css("opacity", 0);
    }
  }

  fadeInControls() {
    if (parseInt($(".controls-container").css("opacity")) !== 1) {
      $(".title-container").css("opacity", 1);
      $(".controls-container").css("opacity", 1);
      $(".voting-container").css("opacity", 1);
    }
  }

  private startTimer() {
    let timer$ = timer(1, 10);
    this.timerSubscription = timer$.subscribe((t) => {
      this.ticks++;
      if (this.ticks >= 400 && !this.mediaFinished) {
        this.fadeOutControls();
      } else {
        if (this.mouseInScreen && !this.mediaFinished) {
          this.fadeInControls();
        }
      }
    });
  }
}
